export const toFixed = (num, figure = 0) => {
    const base = Math.pow(10, figure);
    return Math.round(num * base) / base;
};
export const formatFileSize = (size, base = 1000) => {
    if (typeof size !== 'number') {
        return '';
    }
    let baseSize = Math.pow(base, 3);
    if (size >= baseSize) {
        return toFixed(size / baseSize, 1) + 'G';
    }
    baseSize /= base;
    if (size >= baseSize) {
        return toFixed(size / baseSize, 1) + 'M';
    }
    baseSize /= base;
    if (size >= baseSize) {
        return toFixed(size / baseSize, 1) + 'K';
    }
    return toFixed(size, 1) + 'B';
};
export const sizeTransform = (size, unit = 'M', figure = 1) => {
    const units = ['B', 'K', 'M', 'G', 'T'];
    const index = units.indexOf(unit);
    if (index === -1) {
        return size;
    }
    const base = 1000 ** index;
    return toFixed(size / base, figure);
};
export const getFileExt = (filename) => (!filename || !filename.length ? '' : filename.replace(/.+\.(?=\w+$)/, '').toLowerCase());
export const isDuplicateFile = (file1, file2) => file1.size === file2.size && file1.name === file2.name && file1.type === file2.type && file1.mailId === file2.mailId;
